import useCommonResponsiveValues from 'app/hooks/useCommonResponsiveValues'
import {
	Box,
	VStack,
	Text,
	useBreakpointValue,
	Stack,
	HStack,
} from 'native-base'
import colors from 'app/colors'
import Svg from 'app/features/component/svg'
const IntroSection3 = () => {
	const { containerWidth } = useCommonResponsiveValues()

	const paddingY = useBreakpointValue({
		base: '48px',
		lg: '120px',
	})

	const textSize2Props = useBreakpointValue({
		base: 'h3/800',
		lg: 'h2/900',
	})

	const messageList = useBreakpointValue({
		base: [
			'교과서나 문제집에 모르는 단어가 \n나오면 그냥 넘어가지 않고 \n의미를 찾아보나요?',
			'학교나 학원에서 배운 수업내용을 \n노트에 잘 정리하고 있나요?',
			'학교에서 선생님께서 주시는 자료들을 \n잘 모아 두었고 필요할 때 찾아보나요?',
			'예전에는 잘 못했지만 \n지금은 잘 하는 과목이 있나요?',
			'학교 숙제를 빠짐없이 성실하게 \n잘 제출하고 있나요?',
			'학교의 다양한 행사와 대회에 \n열심히 참여하고 있나요?',
		],
		lg: [
			'교과서나 문제집에 모르는 단어가 나오면 그냥 넘어가지 않고 의미를 찾아보나요?',
			'학교나 학원에서 배운 수업내용을 노트에 잘 정리하고 있나요?',
			'학교에서 선생님께서 주시는 자료들을 잘 모아 두었고 필요할 때 찾아보나요?',
			'예전에는 잘 못했지만 지금은 잘 하는 과목이 있나요?',
			'학교 숙제를 빠짐없이 성실하게 잘 제출하고 있나요?',
			'학교의 다양한 행사와 대회에 열심히 참여하고 있나요?',
		],
	})

	return (
		<Box bgColor={colors.grey100} alignItems="center" py={paddingY}>
			<Stack
				px={{ base: '16px', lg: '24px' }}
				py={{ base: '4px', lg: '8px' }}
				borderRadius="60px"
				borderWidth="2px"
				borderColor={colors.grey800}
			>
				<Text
					size={useBreakpointValue({
						base: 'p_s/600',
						lg: 'h5/600',
					})}
				>
					다양한 교육기관에서 활용하여 검증된
				</Text>
			</Stack>
			<Box h={{ base: '12px', lg: '24px' }} />
			<Text
				color="singletons.black"
				size={textSize2Props}
				textAlign="center"
			>
				종합학습진단 문항
			</Text>
			<Box h={{ base: '40px', lg: '60px' }} />
			<VStack w={containerWidth} alignItems="center">
				<Stack
					bgColor={colors.white50}
					borderRadius="24px"
					w={{ base: '343px', lg: '684px' }}
					h={{ base: '588px', lg: '420px' }}
					py={{ base: '36px', lg: '36px' }}
					px={{ base: '24px', lg: '42px' }}
					style={[
						{
							shadowOffset: {
								width: 0,
								height: 16,
							},
							shadowOpacity: 0.1,
							shadowRadius: 24,
						},
					]}
				>
					{messageList.map((value: string, index: number) => {
						return (
							<HStack
								key={index}
								py="10px"
								alignItems={useBreakpointValue({
									base: 'start',
									lg: 'center',
								})}
							>
								<Box
									borderRadius="4px"
									alignItems="center"
									justifyContent="center"
									bgColor={colors.grey700}
									width="24px"
									height="24px"
								>
									<Text
										textAlign="center"
										size="p_xs/800"
										color={colors.white50}
									>
										{index + 1}
									</Text>
								</Box>
								<Text
									ml="8px"
									size="h7/500"
									color={colors.grey700}
								>
									{value}
								</Text>
							</HStack>
						)
					})}
					<Stack alignItems="center" mt="20px">
						<Box
							width="4px"
							height="4px"
							bgColor={colors.grey500}
							borderRadius="2px"
						/>
						<Box
							width="4px"
							height="4px"
							bgColor={colors.grey500}
							borderRadius="2px"
							mt="8px"
						/>
						<Box
							width="4px"
							height="4px"
							bgColor={colors.grey500}
							borderRadius="2px"
							mt="8px"
						/>
					</Stack>
					<HStack mt="20px" justifyContent="center">
						<Svg
							width="24px"
							height="24px"
							asset={require('app/assets/main/ic_file-plus-line.svg')}
							src="/main/ic_file-plus-line.svg"
						/>
						<Text ml="10px" size="h6/700" color={colors.green400}>
							추가 88문항
						</Text>
					</HStack>
				</Stack>
				<Box
					height={useBreakpointValue({
						lg: '120px',
						base: '54px',
					})}
				/>
				<HStack flexWrap="wrap">
					<Stack
						mx={{ base: '7px', lg: '10px' }}
						my="12px"
						bgColor={colors.grey900}
						width={{ base: '168px', lg: '236px' }}
						height={{ base: '168px', lg: '236px' }}
						borderRadius={{ base: '84px', lg: '118px' }}
					>
						<Text
							mt={useBreakpointValue({
								base: '36px',
								lg: '48px',
							})}
							textAlign="center"
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							01
						</Text>
						<Text
							mt={useBreakpointValue({
								base: '8px',
								lg: '24px',
							})}
							color={colors.white50}
							textAlign="center"
							size={useBreakpointValue({
								base: 'p_s/700',
								lg: 'h7/700',
							})}
						>
							학생부 종합전형{'\n'}
							공통 평가요소 체크리스트{'\n'}
							반영
						</Text>
					</Stack>
					<Stack
						mx={{ base: '7px', lg: '10px' }}
						my="12px"
						bgColor={colors.grey900}
						width={{ base: '168px', lg: '236px' }}
						height={{ base: '168px', lg: '236px' }}
						borderRadius={{ base: '84px', lg: '118px' }}
					>
						<Text
							mt={useBreakpointValue({
								base: '36px',
								lg: '48px',
							})}
							textAlign="center"
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							02
						</Text>
						<Text
							mt={useBreakpointValue({
								base: '8px',
								lg: '24px',
							})}
							color={colors.white50}
							textAlign="center"
							size={useBreakpointValue({
								base: 'p_s/700',
								lg: 'h7/700',
							})}
						>
							국가수준 학업 성취도{'\n'}
							평가결과 반영
						</Text>
					</Stack>
				</HStack>
				<HStack mt={{ base: '12px', lg: '0px' }} flexWrap="wrap">
					<Stack
						mx={{ base: '7px', lg: '10px' }}
						my="12px"
						bgColor={colors.grey900}
						width={{ base: '168px', lg: '236px' }}
						height={{ base: '168px', lg: '236px' }}
						borderRadius={{ base: '84px', lg: '118px' }}
					>
						<Text
							mt={useBreakpointValue({
								base: '36px',
								lg: '48px',
							})}
							textAlign="center"
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							03
						</Text>
						<Text
							mt={useBreakpointValue({
								base: '8px',
								lg: '24px',
							})}
							color={colors.white50}
							textAlign="center"
							size={useBreakpointValue({
								base: 'p_s/700',
								lg: 'h7/700',
							})}
						>
							대학 교육 협회에서 정한{'\n'}
							인재 기준 반영
						</Text>
					</Stack>
					<Stack
						mx={{ base: '7px', lg: '10px' }}
						my="12px"
						bgColor={colors.grey900}
						width={{ base: '168px', lg: '236px' }}
						height={{ base: '168px', lg: '236px' }}
						borderRadius={{ base: '84px', lg: '118px' }}
					>
						<Text
							mt={useBreakpointValue({
								base: '36px',
								lg: '48px',
							})}
							textAlign="center"
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							04
						</Text>
						<Text
							mt={useBreakpointValue({
								base: '8px',
								lg: '24px',
							})}
							color={colors.white50}
							textAlign="center"
							size={useBreakpointValue({
								base: 'p_s/700',
								lg: 'h7/700',
							})}
						>
							정확도를 높이기 위한{'\n'}
							대학 입시 결과{'\n'}
							30만건 분석
						</Text>
					</Stack>
				</HStack>
				<Box
					height={useBreakpointValue({
						lg: '60px',
						base: '40px',
					})}
				/>
				<Text
					color={colors.grey700}
					textAlign="center"
					size={useBreakpointValue({
						base: 'p_s/600',
						lg: 'h5/500',
					})}
				>
					위 요소들을 바탕으로 제작된 96개의 평가문항은 {'\n'}
					입시에서 우수한 평가를 받을 수 있는{'\n'}내 아이만의 공부
					로드맵으로 재탄생됩니다.{'\n'}
				</Text>
			</VStack>
		</Box>
	)
}

export default IntroSection3
